import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_stock_level_monitoring_run_fi_label_hdr_link_RowClass } from '../../../dbschema/bl_inv_stock_level_monitoring_run_fi_label_hdr_link.model';

export class StockLevelMonitoringRunFiLabelHdrLinkModel extends BaseContainerModel {
  bl_inv_stock_level_monitoring_run_fi_label_hdr_link: bl_inv_stock_level_monitoring_run_fi_label_hdr_link_RowClass = new bl_inv_stock_level_monitoring_run_fi_label_hdr_link_RowClass();
}
